import React from "react";
import "./App.css";
import RouterNavigation from "./admin-panel/config/router";
import "./constant/main.css";
import "./constant/main-media-query.css";
import { positions, Provider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import StudentPanelRouterNavigation from "./student-panel/config/router";
import TutorPanelRouterNavigation from "./tutor-panel/config/router";
import { BrowserRouter, Routes, Route } from "react-router-dom";
const options = {
  timeout: 2500,
  position: positions.BOTTOM_CENTER,
  containerStyle: {
    zIndex: 1000000,
  },
};
let App = () => {
  return (
    <Provider template={AlertTemplate} {...options}>
      <RouterNavigation />
      <StudentPanelRouterNavigation />
      <TutorPanelRouterNavigation />
    </Provider>
  );
};
export default App;
